
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-label":"environment-svg"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('environment')]),_c('path',{attrs:{"d":"M14.793 9.435L2.065 22.163","stroke":"#63756B","stroke-width":"2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.065 18.577a7 7 0 01-.757-10.556c2.714-2.714 7.458-4.403 13.68-3.86.348 6.618-1.088 11.066-3.78 13.76a7 7 0 01-7.303 1.644l-1.528 1.529a9.004 9.004 0 0010.244-1.76c3.515-3.514 4.95-9.192 4.243-16.97-7.425-1.06-13.456.728-16.97 4.243a9 9 0 00.745 13.396l1.426-1.426z","fill":"#63756B"}})])
          )
        }
      }
    